import { AnalyticsEvent } from 'analytics';
import { HTML5EventType } from 'Workspace/TelemetryEvents/TelemetryEventTypes';

type HTML5EventMetaData = {
	messageType: string;
	correlationId?: string;
};

const code = 'WSUI_HTML5';

const preparePayload = (type: string, metadata: HTML5EventMetaData): AnalyticsEvent => ({
	type,
	code,
	...metadata,
});

export const HTML5EventPayload = {
	postMessageSent: (data: HTML5EventMetaData): AnalyticsEvent =>
		preparePayload(HTML5EventType.PostMessageSent, data),
	postMessageReceived: (data: HTML5EventMetaData): AnalyticsEvent =>
		preparePayload(HTML5EventType.PostMessageReceived, data),
};
